/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metric_Launch_Switch_To_AgeInputs */



/**
* | output |
* | --- |
* | "Switch to Age" |
*
* @param {Metric_Launch_Switch_To_AgeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const metric_launch_switch_to_age = /** @type {((inputs?: Metric_Launch_Switch_To_AgeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metric_Launch_Switch_To_AgeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Switch to Age")
});